import { render, staticRenderFns } from "./PayCaiBi.vue?vue&type=template&id=0f6d07b0&scoped=true&"
import script from "./PayCaiBi.vue?vue&type=script&lang=js&"
export * from "./PayCaiBi.vue?vue&type=script&lang=js&"
import style0 from "./PayCaiBi.vue?vue&type=style&index=0&id=0f6d07b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d07b0",
  null
  
)

export default component.exports